export default __webpack_public_path__ + "static/media/A2.62aa657a.mp3";